import { render, staticRenderFns } from "./SnackbarContainer.vue?vue&type=template&id=5c0c46de"
import script from "./SnackbarContainer.vue?vue&type=script&lang=ts"
export * from "./SnackbarContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports